import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

import { IUserRoleRequest, IUserRoleResponse } from '../models/user-role.model';
import { loadUserRolesRequest, loadUserRolesResponse } from '../actions/user-role.actions';
import { loadUserRolesFailure } from 'src/app/static-data/actions/user-roles.actions';

export const userRoleFeatureKey = 'userRole';

export interface UserRoleState {
  userRoleRequest: IUserRoleRequest;
  userRoleSuccess: IUserRoleResponse;
  userRoleFailure: IGenericError<ErrorResponse>;
}

export const initialState: UserRoleState = {
  userRoleRequest: undefined,
  userRoleSuccess: undefined,
  userRoleFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadUserRolesRequest, (state, action) => ({
    ...state,
    userRoleRequest: action.request
  })),
  on(loadUserRolesResponse, (state, action) => ({
    ...state,
    userRoleSuccess: action.response
  })),
  on(loadUserRolesFailure, (state, action) => ({
    ...state,
    userRoleFailure: action.error
  }))
);

export const getUserRoleRequest = (state: UserRoleState) => state.userRoleRequest;
export const getUserRoleResponse = (state: UserRoleState) => state.userRoleSuccess;
export const getUserRoleFailure = (state: UserRoleState) => state.userRoleFailure;
